<template>
  <div class="field-agreements container">
    <label :data-field-span="data.FieldSpan" :for="'input_' + data.Id" :data-type="data.Type" >
<!--
      <div class="agreements-header">
        <legend>
          <Localize :text="data.Text" />
        </legend>
      </div>
-->
      <div class="agreements-wrapper">
        <div class="agreements-description" @click="modalListener"><Localize :text="data.Description" /></div>
        <div>
          <SliderCheckbox v-model="inputVal" :data="data" @input="updateValue" />
        </div>
      </div>
    </label>
  </div>
</template>

<script>
import Localize from '@/components/Localize.vue'
import SliderCheckbox from '@/components/SliderCheckbox.vue'
import Terms from '@/services/terms.js'

export default {
  name: 'InputAgreements',
  components: {
    Localize,
    SliderCheckbox
  },
  props: {
    value: String,
    data: Object,
    parent: Object,
    sectionid: String,
    pageid: String,
  },
  data: () => {
    return {

    }
  },
  computed: {
    inputVal: {
      get: function() {
        if (this.value === true || this.value === 'true')
          return true
        return false
      },
      set: function(val) {
        this.$emit('input:change', val + '')
        this.$emit('input', val + '')
        this.$emit('input:value', val + '')
      }
    }
  },
  methods: {
    alert: function(msg) {
      this.$store.commit('openToast', {
        text: msg,
        type: 'warning'
      })
    },
    validate: function(alert) {
      alert = alert === true ? true : false
      this.$nextTick(function () {
        if (this.data.Required)
          this.$emit('input:isvalid', this.inputVal)
        else {
          this.$emit('input:isvalid', true)
          if (this.alert)
            this.alert(this.data.Text + ' is invalid')
        }
      })
    },
    formValidate: function() {
      if (
        this.$store.getters.getSection(this.sectionid) != null &&
        this.$store.getters.getPage(this.pageid) != null
      )
        this.validate(false) // Change to true to alert
    },
    updateValue: function (val) {
      this.inputVal = val
    },
    modalListener: function (ev) {
      if (ev.target.tagName !== 'A')
        return

      if (this.data.Id === 'smart1003_borrower_authorization_credit')
        this.$root.$emit('modal:creditauth')
      else if (this.data.Id === 'smart1003_borrower_privacy_policy')
        this.$root.$emit('modal:privacypolicy')
      else if (this.data.Id === 'smart1003_borrower_edisclosure_agreement')
        this.$root.$emit('modal:econsent')

      ev.preventDefault()
    }
  },
  created: function() {
    if (this.data.Value)
      this.inputVal = this.data.Value
    
    // Validate if pre-filled
    this.validate()

    this.$root.$on('form:validate', this.formValidate)
    this.$root.$on('form:validate-force', this.validate)
    this.$emit('input:created')
  },
  mounted: function () {

  },
  watch: {
    inputVal: function (val) {
      this.validate(false)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';
.field-agreements {
  &.container {
    width: $card-container-width;
  }
  .agreements-header {
    font-weight: 600;
  }
  .agreements-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .agreements-description {
    margin-right: 10px;
  }

  ::v-deep a {
    text-decoration: underline;
  }

  ::v-deep a:hover {
    cursor: pointer;
  }
}

.container {
  .container {
    width: unset;
  }
}

</style>

